import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Config } from "../constant";
import { send } from "../Socket";
import { observer } from "mobx-react";
import Flag from "../assets/Flag.png";
import "../index.css";
// const customPhonenumberStyle = {
//   fontSize: "12px",
//   marginTop: "2.5px"
// };
const customInputStyle = {
  borderBottom: "none",
  marginBottom: "3px"
};
export default observer(
  class FormBody extends Component {
    constructor(props) {
      super(props);
      this.state = {
        error: undefined,
        name: "",
        email: "",
        phoneNumber: "",
        isSessionActive: false,
        counterName: 0,
        counterEmail: 0,
        counterPhonenumber: 0
      };
    }
    static propTypes = {
      name: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      isActive: PropTypes.bool
    };
    static defaultProps = {
      isActive: false
    };

    onSubmit = () => {
      const { counterName, counterEmail, counterPhonenumber } = this.state;
      if (counterName + counterEmail + counterPhonenumber === 3) {
        var sessionCreate = JSON.stringify({
          code: Config.initialCode,
          domain: Config.domain(),
          accessToken: Config.accessToken(),
          tokenSecret: Config.tokenSecret(),
          domainId: Config.domainId(),
          userAgent: Config.userAgent,
          displayPicture: "",
          timezone: Config.timezone,
          email: this.state.email,
          name: this.state.name,
          phoneNumber: "62" + this.state.phoneNumber
        });
        send(sessionCreate);
        this.props.onChangeSession();
      }
    };
    render() {
      // const { name, email, phoneNumber, isActive } = this.props;
      const { displayPicture } = this.props
      const { counterName, counterEmail, counterPhonenumber } = this.state;
      return (
        <Screen className="form-body">
          <Wrapper>
            <LogoWrapper>
              <Logo alt="logochat" src={displayPicture} />
            </LogoWrapper>
            <TextWrapper>
              <Text>
                Thanks for contacting us. Please complete this form and{" "}
                <b>Start Chat.</b>
              </Text>
            </TextWrapper>
            <Panel>
              <Label>Name</Label>
              <Input
                label="Name User"
                name="nameuser"
                value={this.state.name}
                type="text"
                placeholder="Your Name"
                name={this.props.name}
                onChange={e => {
                  if (e.target.value.length === 0) {
                    this.setState({ counterName: 0 });
                  } else {
                    this.setState({ counterName: 1 });
                  }
                  this.setState({ name: e.target.value, counterName: 1 });
                }}
              />{" "}
              <Label>Email</Label>
              <Input
                label="Email"
                name="email"
                value={this.state.email}
                type="email"
                placeholder="Your E-mail"
                email={this.props.email}
                onChange={e => {
                  if (e.target.value.length === 0) {
                    this.setState({ counterEmail: 0 });
                  } else {
                    this.setState({ counterEmail: 1 });
                  }
                  this.setState({ email: e.target.value });
                }}
              />
              <Label>Phone Number</Label>
              <PhoneNumberWrapper>
                <DropDownWrapper>
                  <FlagWrapper alt="bendera indonesia" src={Flag} />
                  <DropDownText>+62</DropDownText>
                </DropDownWrapper>
                <InputPhoneNumber>
                  {" "}
                  <Input
                    label="Phone Number"
                    type="number"
                    name="phonenumber"
                    min="0"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    phoneNumber={this.props.phoneNumber}
                    value={this.state.phoneNumber}
                    style={customInputStyle}
                    placeholder="Your Phone Number"
                    onChange={e => {
                      if (e.target.value.length === 0) {
                        this.setState({ counterPhonenumber: 0 });
                      } else {
                        this.setState({ counterPhonenumber: 1 });
                      }
                      this.setState({ phoneNumber: e.target.value });
                    }}
                  />
                </InputPhoneNumber>
              </PhoneNumberWrapper>
              <SubmitButton>
                <Submit
                  type="Submit"
                  onClick={this.onSubmit}
                  isActive={
                    counterName + counterEmail + counterPhonenumber === 3
                  }
                >
                  Start Chat{" "}
                </Submit>
              </SubmitButton>
            </Panel>
          </Wrapper>
        </Screen>
      );
    }
  }
);

const Screen = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  border-radius: 5px;
  background: linear-gradient(90deg, #2db7a2, #35adac, #4e8ec8);
  border-radius: 5px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
  width: 300px;
  height: 375px;

  @media (max-width: 600px) {
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-radius: 5px;
    background: linear-gradient(90deg, #2db7a2, #35adac, #4e8ec8);
    border-radius: 5px;
    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
  }
  @media (max-height: 400px) {
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-radius: 5px;
    background: linear-gradient(90deg, #2db7a2, #35adac, #4e8ec8);
    border-radius: 5px;
    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
    width: 100%;
    height: auto;
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25%;
  width: 100%;

  @media (max-width: 430px) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25%;
    width: 100%;
    margin: 15px 0 10px 0;
  }
`;
const Logo = styled.img`
  width: auto;
  height: 75%;
  @media (max-width: 430px) {
    width: auto;
    height: 75px;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  margin: 0 7% 0 7%;
`;

const Text = styled.div`
  font-size: 0.8em;
  color: white;
  text-align: justify;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  @media (max-width: 460px) {
    font-size: 0.7em;
    color: white;
    text-align: justify;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
`;
const Panel = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2% 7% 9% 7%;
  width: auto;
  height: auto;
`;

const Label = styled.label`
  color: white;
  margin: 0 0 5px 0;
  font-size: 0.75em;
  font-family: "Source Sans Pro", sans-serif;
  @media (max-width: 430px) {
    color: white;
    margin: 0 0 2% 0;
    font-family: "Source Sans Pro", sans-serif;
  }
`;

const Input = styled.input`
  background-color: transparent;
  border: 0px;
  border-bottom: solid 2px white;
  margin-bottom: 10px;
  padding: 3px;
  color: #ffffff;
  font-size: 0.7em;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  ::placeholder {
    color: white;
    opacity: 0.3364;
  }
  &:focus {
    font-weight: bold;
    outline: none;
  }
`;

const PhoneNumberWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: solid 2px white;
`;
const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 20%;
  justify-content: center;
  border-right: solid 2px white;
  margin: 1% 1% 2% 0;
  padding-right: 1%;
  line-height: 3;
`;
const FlagWrapper = styled.img`
  display: flex;
  margin-right: 4px;
  height: 10.53px;
  width: 16.33px;
  align-self: center;
  @media (max-width: 320.98px) {
    display: flex;
    margin-right: 4px;
    height: 8.48px;
    width: 14.87px;
    align-self: center;
  }
  @media (max-width: 410px) {
    display: flex;
    margin-right: 4px;
    height: 9.5px;
    width: 15.5px;
    align-self: center;
  }
  @media (max-width: 520.98px) {
    display: flex;
    margin-right: 4px;
    height: 9.69px;
    width: 15.97px;
    align-self: center;
  }
  @media (max-width: 800.98px) {
    display: flex;
    margin-right: 4px;
    height: 10.23px;
    width: 16.2px;
    align-self: center;
  }
`;

const InputPhoneNumber = styled.div`
  display: flex;
  width: 80%;
  margin-left: 3px;
  align-items: flex-end;
`;

const DropDownText = styled.span`
  color: #ffffff;
  font-size: 0.75em;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  @media (max-width: 320.98px) {
    color: #ffffff;
    font-size: 0.65em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
  @media (max-width: 410px) {
    color: #ffffff;
    font-size: 0.675em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
  @media (max-width: 520.98px) {
    color: #ffffff;
    font-size: 0.7em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
  @media (max-width: 800.98px) {
    color: #ffffff;
    font-size: 0.725em;
    line-height: 1.5;
    font-family: "Source Sans Pro", sans-serif;
  }
`;

const SubmitButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
`;

const Submit = styled.button`
  font-size: 0.7em;
  align-content: center;
  align-self: center;
  padding: 8px 15px 8px 15px;
  border: none;
  border-radius: 14px;
  margin-top: -10px;
  font-family: "Source Sans Pro", sans-serif;
  ${props =>
    !props.isActive &&
    css`
      background: #bababa;
      color: #9f9f9f;
    `};
  ${props =>
    props.isActive &&
    css`
      color: #6bbcf4;
      background: white;
    `};
`;



// WEBPACK FOOTER //
// ./src/form/FormBody.js